<span *ngIf="dateRange === dateRangeFilter.ONE_WEEK" class="label">{{'Last week' | translate}}</span>
<span *ngIf="dateRange === dateRangeFilter.FOUR_WEEKS" class="label">{{'Last 4 weeks' | translate}}</span>
<span *ngIf="dateRange === dateRangeFilter.TWELVE_WEEKS" class="label">{{'Last 12 weeks' | translate}}</span>
<span *ngIf="dateRange === dateRangeFilter.LAST_THREE_MONTHS" class="label">{{'Last 3 months' | translate}}</span>
